export default "__VITE_ASSET__ICMtV2EV__"